import React, { Fragment, useState, useEffect } from 'react';
import './CampaignFooter.scss';
import axios from 'axios';

function CampaignFooter() {
  const currentUrl = window.location.href;
  const [relatedContentsData, setRelatedContentsData] = useState();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await axios(
          'https://related-contents-datas.s3.amazonaws.com/narRelatedContents.json'
        );
        const data = JSON.parse(JSON.stringify(result.data));
        setRelatedContentsData(data.refresh);
      } catch (error) {
        console.log('theres an error', error);
      }
    };
    fetchData();
  }, []);

  return (
    <section className="relatedContents">
      <div className="relatedContents__tiles">
        {relatedContentsData &&
          relatedContentsData.map((data, i) => {
            return (
              <Fragment key={data.content}>
                {currentUrl !== data.url ? (
                  <div
                    className={
                      relatedContentsData[i + 1]
                        ? i === 0
                          ? `relatedContents__tile relatedContents__tile-${data.content} relatedContents__tile-first`
                          : `relatedContents__tile relatedContents__tile-${data.content}`
                        : `relatedContents__tile relatedContents__tile-${data.content} relatedContents__tile-last`
                    }
                    key={i}
                    style={{ backgroundImage: `url(${data.background})` }}
                  >
                    <div className="relatedContents__tile--contents relatedContents__tile__content">
                      <h4 className="relatedContents__tile__title">{data.title}</h4>
                      <p className="relatedContents__tile__body">{data.body}</p>
                      <a
                        className="relatedContents__tile__link"
                        href={data.url}
                        target="_blank"
                        rel="sponsored"
                        aria-label={data.label}
                      >
                        <div className="buttons">{data.button}</div>
                      </a>
                    </div>
                  </div>
                ) : (
                  <></>
                )}
              </Fragment>
            );
          })}
      </div>
    </section>
  );
}

export default CampaignFooter;
